<template>
  <div class="tag-content">
    <el-menu default-active="tag-manage" class="el-menu-demo" mode="horizontal" :router="true">
      <el-menu-item index="list">竞赛管理</el-menu-item>
      <el-menu-item index="tag-manage" class="right is-active">标签课程</el-menu-item>
      <el-menu-item index="category" class="right">分类管理</el-menu-item>
    </el-menu>

    <div class="tab-item">
      <el-menu class="el-menu-demo" mode="horizontal" :router="true">
        <el-menu-item index="tag-manage" class="is-active">标签管理</el-menu-item>
        <el-menu-item index="tag-group-manage">标签组管理</el-menu-item>
      </el-menu>
      <div class="add-box">
        <el-button type="primary" @click="dialogTagVisible = true">添加标签</el-button>
      </div>
      <template>
        <el-table :data="tableData" style="width: 100%" :header-cell-style="{background:'#f5f5f5',color:'#555'}">
          <el-table-column prop="name" label="标签名称" width="300"></el-table-column>
          <el-table-column prop="groupNames" label="所属标签组" width="300">
            <template slot-scope="scope">
              <template v-for="item in scope.row.groupNames">{{item}} </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="editTag(scope.row.id,scope.row.name)">编辑</el-button>
              <el-button size="mini" @click="deleteTag(scope.row.id,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="tempId?'编辑标签':'添加标签'" width="600px" :visible.sync="dialogTagVisible" :close-on-click-modal="false" :before-close="cancelTag">
          <el-form :model="tagValue" ref="tagForm" :rules="tagRules" label-width="100px" @submit.native.prevent>
            <el-form-item label="标签名称" prop="name">
              <el-input v-model.trim="tagValue.name" placeholder="请输入标签名称" autocomplete="off" autofocus="true"></el-input>
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button type="primary" @click="addTag">确定</el-button>
            <el-button @click="cancelTag">取消</el-button>
          </template>
        </el-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getTagData,
  addTagData,
  editTagData,
  deleteTagData,
  checkTagName
} from "@/api/course";
import qs from "qs";
export default {
  components: {},
  mounted() {
    this.initTagData();
  },
  watch: {
  },
  data() {
    var tagValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入标签名'));
      }
      if (value.length > 20) {
        return callback(new Error('标签名称的长度必须小于等于20'));
      }
      let params = {
        exclude: this.tempName,
        value: value
      }
      checkTagName(params).then(response => {
        if (!response.data.success) {
          callback(new Error('标签已存在'));
        } else {
          callback()
        }
      })
    };
    return {
      activeName: "first",
      tableData: [], //标签数据
      dialogTagVisible: false,//标签添加窗口
      tagValue: {
        name: ""
      },
      tagRules: {
        name: [
          { required: true, validator: tagValidator, trigger: "blur" }
        ],
      },
      tempId: "",//临时的标签id
      tempName: '',//临时的标签名
    };
  },
  methods: {
    //获取标签
    initTagData: function () {
      getTagData().then(response => {
        this.tableData = response.data.tags;
      });
    },
    //添加标签
    addTag: function () {
      this.$refs["tagForm"].validate(valid => {
        if (valid) {
          let params = {
            name: this.tagValue.name
          };
          if (!this.tempId) {
            addTagData(qs.stringify(params)).then(response => {
              if (response.code === 200) {
                this.tableData.unshift(response.data.tag);
                this.$message.success("添加成功!");
              } else {
                this.$message.success("添加失败!");
              }
            });
          } else {
            //获取当前修改的index下标
            let index = this.tableData.findIndex(val => {
              return val.id == this.tempId;
            });
            editTagData(this.tempId, qs.stringify(params)).then(response => {
              if (response.code === 200) {
                if (index !== -1) {
                  this.tableData.splice(index, 1, response.data.tag);
                }
                this.$message.success("保存成功!");
              } else {
                this.$message.success("保存失败!");
              }
            });
          }
          this.cancelTag();
        }
      });
    },
    //编辑标签
    editTag: function (id, name) {
      this.dialogTagVisible = true;
      this.tagValue.name = name;
      this.tempId = id;
      this.tempName = name;
    },
    //删除标签
    deleteTag: function (id, index) {
      this.$confirm("真的要删除该标签吗？", "删除标签", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id: id
          };
          this.tableData.splice(index, 1);
          deleteTagData(params).then(response => {
            this.$message.success("删除成功!");
          });
        })
        .catch(() => { });
    },
    //关闭添加标签窗口
    cancelTag: function () {
      this.$refs.tagForm.resetFields(); //关闭前清空表单
      this.dialogTagVisible = false;
      this.tempId = "";
      this.tempName = "";
      this.tagValue.name = ''
    },
  },
  directives: {
    focus: {
      inserted: function (el, { value }) {
        //聚焦元素
        el.querySelector("input").focus();
        el.querySelector("input").select();
      }
    }
  }
};
</script>

<style scoped>
.tag-content {
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.tag-content .el-menu {
  margin-bottom: 15px;
}
.tag-content .tab-item .el-menu-item {
  line-height: 45px;
  height: 45px;
}
.tag-content .tab-item .el-menu-item.is-active {
  border: 1px solid #dce1e6;
  border-bottom-color: #fff;
  color: #409eff;
}
.tag-content .tab-item {
  position: relative;
}
.tag-content .add-box {
  position: absolute;
  top: -5px;
  right: 0;
}
</style>
